// app/providers.jsx
'use client';
import posthogClient from 'posthog-js';
import { PostHogProvider as PHProvider } from 'posthog-js/react';
import { useEffect } from 'react';

export function PostHogProvider({ children }: { children: React.ReactNode }) {
  const posthogKey = process.env.NEXT_PUBLIC_POSTHOG_KEY;
  const hasValidPosthogKey = typeof posthogKey === 'string' && posthogKey.startsWith('phc_');
  const isOffline = process.env.APP_ENV === 'offline';

  // Offline/local setups use placeholder keys. Don't initialize PostHog
  // because it produces noisy 401 errors and slows local boot.
  const shouldDisableAnalytics = process.env.NEXT_PUBLIC_SKIP_ANALYTICS === 'true' || isOffline || !hasValidPosthogKey;

  useEffect(() => {
    if (shouldDisableAnalytics) {
      return;
    }

    posthogClient.init(posthogKey, {
      api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST,
      person_profiles: 'identified_only', // or 'always' to create profiles for anonymous users as well
      loaded: (posthog) => {
        if (process.env.NODE_ENV === 'development') posthog.debug();
      },
    });
  }, [posthogKey, shouldDisableAnalytics]);

  if (shouldDisableAnalytics) {
    return <>{children}</>;
  }

  return <PHProvider client={posthogClient}>{children}</PHProvider>;
}
